export function mappingPostData(query) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SUBMIT_POST',
                query,
            })
        );
}

export function mappingSetBulkMapping(bulkMappingType) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SET_BULK_MAPPING',
                bulkMapping: !!bulkMappingType,
                bulkMappingType,
            })
        );
}

export function mappingSetData(mappingData, replaceMappingData = false, showMessage = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SET_MAPPING_DATA',
                mappingData,
                replaceMappingData,
                showMessage,
            })
        );
}

export function mappingSetDataFromShell(replaceMappingData = false, showMessage = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SET_MAPPING_DATA_FROM_SHELL',
                replaceMappingData,
                showMessage,
            })
        );
}

export function mappingSetMassMapping(massMapping = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SET_MASS_MAPPING',
                massMapping,
            })
        );
}

export function mappingSetShowMessage(showMessage = true) {
    return (dispatch) => {
        dispatch({
            type: 'MAPPING_SET_SHOW_MESSAGE',
            showMessage,
        });
    };
}

export function mappingSetShowRememberMapping(showRememberMapping = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SET_SHOW_REMEMBER_MAPPING',
                showRememberMapping,
            })
        );
}

export function mappingResetContentType(contentType, showMessage = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_RESET_CONTENT_TYPE',
                contentType,
                showMessage,
            })
        );
}

export function mappingReset(fullReset) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_RESET',
                fullReset,
            })
        );
}

export function mappingCancelMapping() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_CANCEL_MAPPING',
            })
        );
}

export function mappingGoToNextMediaItem(refreshServiceDataKey) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_GO_TO_NEXT_MEDIAITEM',
                refreshServiceDataKey,
            })
        );
}

export function mappingSkipMassMapping() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_SKIP_MASS_MAPPING',
            })
        );
}

export function mappingCreateCustomShell(moviesAndProgramsData) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_CREATE_CUSTOM_SHELL',
                moviesAndProgramsData,
            })
        );
}

export function mappingCompleteMapping() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MAPPING_COMPLETE_MAPPING',
            })
        );
}
